// src/utils/ga.js
export function gaEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", name, {
    ...params,
    page_path:
      window.location.pathname + window.location.search + window.location.hash,
  });
}
